export enum AiConnectionFields {
  name = "name",
  provider = "provider",
  model = "model",
  enabled = "enabled",
}
